import { forwardRef, OnChanges, OnInit, SimpleChange } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { debounceTime } from 'rxjs/operators';
import english from '../../../../main/maintenances/i18n/en.json';
import spanish from '../../../../main/maintenances/i18n/es.json';
import portuguese from '../../../../main/maintenances/i18n/pt.json';
import { EquipmentsApi } from '../../../api/equipments/equipments.api';
export function ValidateAutocomplete() {
    return { required: true };
}
var INPUT_FIELD_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return EquipmentsComponent; }),
    multi: true
};
var EquipmentsComponent = /** @class */ (function () {
    function EquipmentsComponent(fuseTranslationLoaderService, equipmentsApi) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.equipmentsApi = equipmentsApi;
        this.appearance = 'outline';
        this.equipments = [];
        this.inputValue = new FormControl();
        this.loading = false;
        this.onChange = function () { };
        this.onTouched = function () { };
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
        if (this.required) {
            this.inputValue.setValidators(ValidateAutocomplete);
        }
    }
    EquipmentsComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.disabled) {
            this.inputValue.disable();
        }
        this.inputValue.valueChanges.pipe(debounceTime(500)).subscribe(function (value) {
            _this.equipments = [];
            if (value) {
                _this.searchEquipments({
                    name_or_number_contains: value,
                    locationId_in: _this.locationsId,
                    segmentId_in: _this.segment.id
                });
            }
        });
    };
    EquipmentsComponent.prototype.ngOnChanges = function (changes) {
        for (var propertyName in changes) {
            if (propertyName === 'disabled') {
                var disabledValue = changes[propertyName].currentValue;
                if (disabledValue) {
                    this.inputValue.disable();
                }
                else {
                    this.inputValue.enable();
                }
            }
        }
    };
    EquipmentsComponent.prototype.searchEquipments = function (query) {
        var _this = this;
        this.loading = true;
        this.equipmentsApi.getEquipments(query).subscribe((function (result) {
            _this.loading = false;
            _this.equipments = result.items;
        }));
    };
    EquipmentsComponent.prototype.writeValue = function (equipmentId) {
        var _this = this;
        if (equipmentId) {
            this.equipmentsApi.searchOne(equipmentId).subscribe(function (equipment) {
                _this.selectedEquipment = equipment;
                _this.inputValue.setErrors(null);
            });
        }
        else {
            this.unselectEquipment();
        }
    };
    EquipmentsComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    EquipmentsComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    EquipmentsComponent.prototype.setSelectedEquipment = function () {
        var _this = this;
        if (this.inputValue.value) {
            this.selectedEquipment = this.equipments.find(function (equipment) { return equipment.id === _this.inputValue.value; });
            this.onChange(this.inputValue.value);
            this.inputValue.setErrors(null);
        }
    };
    EquipmentsComponent.prototype.unselectEquipment = function () {
        this.onChange(null);
        this.inputValue.setValue(null);
        this.selectedEquipment = null;
        this.inputValue.setErrors(null);
    };
    return EquipmentsComponent;
}());
export { EquipmentsComponent };
